import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { IDonor } from '../../../common/payment/models/order.model';
import { IFundraiser, IBasicInfo, ISipCause } from '../../../fundraiser/models/fundraiser.model';
import { ICLientData } from '../../models/client.model';
import { IMainLayoutConfig } from '../../models/main-layout.config';
import { IUser } from '../../models/user.model';
import { ActivatedRoute, NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { DraftDataI } from '../../models/draft.model';
import { PaymentService } from '../payment/payment.service';
import { filter, pairwise } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { STORY_LANGUAGE } from '../../models/i18n/stories/en';

@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  /**All the parent causes for craeating the fundraiser */
  parentCauses = [
    { label: 'Myself', id: 20, value: 'myself', cause: 'Personal' },
    { label: 'Family Member', id: 20, value: 'family', cause: 'Personal' },
    { label: 'Friend', id: 20, value: 'friend', cause: 'Personal' },
    { label: 'Pet or Animal', id: 20, value: 'pet', cause: 'Personal' },
    { label: 'Charity or Non-profit', id: 48, value: 'ngo', cause: 'Ngo' },
    { label: 'Creative', id: 49, value: 'creative', cause: 'Creative' },
  ];
  frCauses = [
    {
      label: 'Medical Treatment',
      value: 'medical'
    },
    {
      label: 'NGO / Charity',
      value: 'ngo'
    },
    {
      label: 'Other Cause',
      value: 'other'
    },
  ];
  startFundraiserWidgetStatus = new BehaviorSubject(false);
  draftData = new BehaviorSubject<DraftDataI>(null);
  isFundraiserLeftDialog = false;
  abondenedCart = new BehaviorSubject<any>(null);

  frCausesVernacular = [
    {
      label: {
        English: 'Medical Treatment',
        Hindi: 'चिकित्सा उपचार',
        Telugu: ' వైద్య చికిత్స',
        Tamil: 'மருத்துவ சிகிச்சை',


      },
      value: 'medical'
    },
    {
      label: {
        English: 'NGO / Charity',
        Hindi: 'एन.जी.ओ / चैरिटी',
        Telugu: 'ఎన్జీఓ / దాతృత్వం',
        Tamil: 'என்ஜிஓ / தொண்டு',


      },
      value: 'ngo'
    },
    {
      label: {
        English: 'Other Cause',
        Hindi: 'अन्य कारण',
        Telugu: 'ఇతర కారణాలు',
        Tamil: 'பிற காரணங்கள்',

      },
      value: 'other'
    },
  ];
  leadQueryType = [
    { value: 'want_to_raise_funds', text: 'Want to raise funds' },
    { value: 'transaction_related_query', text: 'Transaction related query' },
    { value: 'other_query', text: 'Other query' }
  ];
  fundsUsed = [
    { value: 'cancer_treatment', text: 'Cancer treatment' },
    { value: 'accident_treatment', text: 'Accident treatment' },
    { value: 'liver_kidney_transplant', text: 'Liver/Kidney transplant' },
    { value: 'heart_operation', text: 'Heart operation' },
    { value: 'premature_baby', text: 'Pre-mature baby care (NICU)' },
    { value: 'medicines_treatment', text: 'Medicines (Ongoing treatment)' },
    { value: 'memorial', text: 'Memorial (Patient expired)' },
    { value: 'others', text: 'Others' }
  ];
  hospitalStatus = [
    { value: 'currently_hospitalised', text: 'Currently hospitalised' },
    { value: 'hospitalised_in_6months', text: 'Will be hospitalised within 6 months' },
    { value: 'discharged_from_hospital', text: 'Discharged from hospital' },
    { value: 'does_not_require_hospitalisation', text: 'Does not require hospitalisation' }
  ];
  brandSurveyData = [
    { 'value': 'Search Engine (Google, Yahoo, etc)', 'label': 'Search Engine (Google, Yahoo, etc)' },
    { 'value': 'Facebook, Instagram Ad / Post', 'label': 'Facebook, Instagram Ad / Post' },
    { 'value': 'Twitter Ad / Post', 'label': 'Twitter Ad / Post' },
    { 'value': 'YouTube Ad / Post', 'label': 'YouTube Ad / Post' },
    { 'value': 'Brochure / Banner in Hospital', 'label': 'Brochure / Banner in Hospital' },
    { 'value': 'Recommended by Doctor', 'label': 'Recommended by Doctor' },
    { 'value': 'Recommended by Hospital Staff Member', 'label': 'Recommended by Hospital Staff Member' },
    { 'value': 'Recommended By Friend / Family member', 'label': 'Recommended By Friend / Family member' },
    { 'value': 'Ketto Representative', 'label': 'Ketto Representative' },
    { 'value': 'Recommended by NGO', 'label': 'Recommended by NGO' },
    { 'value': 'WhatsApp DM / Group', 'label': 'WhatsApp DM / Group' },
    { 'value': 'Influencer / Content Creator', 'label': 'Influencer / Content Creator' },
    { 'value': 'Newspaper / TV / Billboard', 'label': 'Newspaper / TV / Billboard' }
  ];
  salaryRangeData = [
    { label: '0-5 lakh', value: '0-5 lakh' },
    { label: '5-10 lakh', value: '5-10 lakh' },
    { label: '10-15 lakh', value: '10-15 lakh' },
    { label: '15-20 lakh', value: '15-20 lakh' },
    { label: '20+ lakh', value: '20+ lakh' },
    { label: 'None', value: 'None' },
  ];
  genderData = [
    { label: 'Male', value: 'M' },
    { label: 'Female', value: 'F' },
    { label: 'Other', value: 'NA' },
  ];
  selectedHospital: any;
  startAFrUrls = {
    'medical': 'new/crowdfunding/medical',
    'non-medical': 'new/crowdfunding/non-medical'
  };
  purposeSelected = false;
  isFOS = false;
  adminToken = '';
  nonSysEventsCampaigns = ['/zerodha', '/dream11-for-india', '/inthistogether', '/oyocare-dfy'];
  RAISED = '1100 Crs+';
  DONORS = '72 Lakh+';
  FUNDRAISERS = '3.2 Lakh+';
  PLATFORMFEE = '0%';
  FOLLOWERS = '1.5M +';
  fundraiserCount = '1,50,256';
  /**Call comment card function */
  commentCard = new Subject<any>();
  /**User Information */
  userData = new BehaviorSubject<IUser>(null);
  /**Client machine location info */
  clientLocationData = new BehaviorSubject<ICLientData>(null);

  /**Filter Data for Browse Fundraiser */
  appliedFilters = new BehaviorSubject<any>({ 'category': 'C1', 'type': 'T1', 'location': 'L1' });
  /**Variable to toggle reset on Browse */
  resetFilter = new Subject<any>();
  /**Apply Mobile Filter */
  applyMobileFilter = new Subject<any>();
  /**Counter check to fire b-lazy */
  resetCounter = new BehaviorSubject<boolean>(false);
  /**Counter check to fire b-lazy */
  showApply = new BehaviorSubject<boolean>(false);

  // Theme of the website
  theme = new Subject<any>();

  /**Fundraier Object */
  fundraiser: IFundraiser;
  /**Fundraier Object Basic info*/
  basicInfo = {} as IBasicInfo;

  /**Type of the campaign like story or fundraiser */
  campaignType = '';

  campaignPurpose: any;
  showSocialShare = true;

  /**Header and footer config in main layout */
  mainLayoutConfig = new BehaviorSubject<IMainLayoutConfig>({
    animateHeader: false,
    logoNavigate: true,
    showFooter: true,
    showHeader: true,
    showMenus: true,
    showProfile: true,
    showSearch: true,
    showSecure: false,
    trustedLine: false,
    hideAbandonedCart: false
  });
  /**header logo click event */
  logoOnclik = new Subject<any>();
  /**Scroll into view varaible */
  scrollIntoView = new Subject<{ name: string, scroll: boolean }>();
  /**Open search box */
  openHeaderSearch = new Subject<boolean>();
  /**Beneficiary object */
  beneficiary: any;
  /**Comment tab swith */
  commentTabSwitch = new Subject<string>();
  /**Thankyou banner */
  donationDetails = new BehaviorSubject<IDonor>(null);
  /**The payment option set */
  setPaymentOption = new BehaviorSubject<{
    card?: boolean, netbanking?: boolean, upi?: boolean, paytm?: boolean
  }>({});
  /**Show thank you banner */
  showThankYoubanner = new BehaviorSubject<any>(null);
  /**Meta data of the page */
  metaDataOfPage: any;
  /**The order id of currently activated/created order */
  currentOrderId: any;
  /**Name of the current page */
  pageName = '';
  /**Browse fundraiser filter menu click listner */
  showCouponOffer = true;
  isCategoryMenuCliked: any;
  /**Type of the payment dialoge */
  paymentDialogType = new BehaviorSubject<string>('');
  // lead form hidden field config
  leadMailTo = 'leads.ketto@gmail.com';
  leadMailToInfo = 'info@ketto.org';
  leadSubject = 'You received a new lead';
  leadType = 'P - Talk to us (browse fundraisers)';
  // Social links and button
  social = false;
  // Payment options params
  paymentOption = false;
  // Check if phone pe swith
  isPhonePe = false;
  // check if opened in third party apps like paytm, phonepe
  thirdPartyApp = false;
  // Check if phone pe swith
  isPaytmMini = false;

  public otdpayment = new BehaviorSubject<any>(null);

  /** */
  defaultIPLocation = {
    'country_code': 'IN',
    'country_name': 'India',
    'city_name': 'Mumbai',
    'region_name': 'Maharashtra',
    'latitude': 19.0144100189209,
    'longitude': 72.84793853759766,
    'zip_code': '400099'
  };
  /**User last four digits of the card */
  lastOrderInfo = new BehaviorSubject<any>(null);
  /**Last payment mode */
  lastOrderMode = new BehaviorSubject<{ mode: string, value: string, gateway: string }>({ mode: '', value: '', gateway: '' });
  /**Previos visited page url */
  previousPageURL = '';
  qrOpened = false;
  /**Custom insurance members */
  members = {
    self: { checked: true, count: 1, showCount: false, data: {} },
    spouse: { checked: false, count: 0, showCount: false, data: {} },
    son: { checked: false, count: 0, showCount: true, maxAllowed: 2, data: {} },
    daughter: { checked: false, count: 0, showCount: true, maxAllowed: 2, data: {} }
  };
  /**Covid premiums */
  covidPremiums = {
    '3 Lac': 1563,
    '1.5 Lac': 785,
    '50,000': 443,
  };
  /**Milkar mumbai url */
  milkarMumbai = environment.production ? '/covid19' : '/new/milkarmumbai';
  environment = environment;
  campaignCount: number;
  portfolioCounts = new BehaviorSubject('');
  /**User last four digits of the card */
  globalVar = new ReplaySubject<any>(1);
  selectTipPercentage: any;

  /**Unique Id for truecaller verification */
  req_nonce = '';

  impactData: any;
  subsCount = new BehaviorSubject<any>({});
  private subsCountApiCalled = false;

  /** thank you page url params */
  tyParams: any;
  createCart: any;
  createCartNewUser: any;

  /** Translate Obverable */
  translateLangArray = new BehaviorSubject<any>([]);
  tranlatedLanguage = 'en';
  languageObs = new BehaviorSubject<string>('en');
  medicalbill = [];
  campaignId: any;
  isOrderLoading = false;
  showTimer = false;
  disableUpi = false;
  gtmPageData: any;
  sipActiveOnPayment = new Subject<string>();

  isQuizCompleted = false;
  lastQuizResponse = false;
  // leads mobile number
  contactUsMobNumber = '9930088522';

  paymentOrigin: any;
  typSipAmount: any;
  typSipAmountDefaultINR = 100;
  isFundraiserEnded: any;
  stripeUsToken: any;
  offerActivated = new ReplaySubject<number>(1);
  validCausePM = [4, 7, 59, 103, 150, 156, 159];

  campaignIdForSip: any;
  trucallerRes = new Subject<{ name: string, phone: string, email: string }>();

  /**check for memorial sip */
  sip_cause = new BehaviorSubject<ISipCause>(null);

  previousUrl: any;

  showDock = new Subject<boolean>();


  criteoPartnerIDs = {
    'IN': 56509,
    'AE': 69550
  };

  currencyObj: any;
  onUpiOptionClick = new Subject<{
    panelClass: string,
    name: string,
    route: string,
  }>();

  appLink = {
    android: 'https://play.google.com/store/apps/details?id=org.ketto.sip',
    android_mcd: 'https://play.google.com/store/apps/details?id=org.ketto.mcd',
    iOS: 'https://apps.apple.com/sr/app/ketto-sip/id1582755806',
    iOS_mcd: 'https://apps.apple.com/sr/app/ketto-for-fundraiser/id1602237545',
    app_flyer: 'https://kettosip.onelink.me/95wu/q1hg3zku',
    app_flyer_android: 'https://kettosip.onelink.me/95wu/jgrg5im3'
  };

  upiTimer = false;
  santaTheme = false;

  deviceType: any;
  clickedAnywhere = false;

  loginMethod: string = '';
  loginType: string = '';

  upi_payment_status = new BehaviorSubject<'success' | 'failed' | 'canceled' | ''>('');

  min_sip_amounts = { INR: 100, USD: 10, GBP: 10, EUR: 10, AED: 20, SGD: 30, SAR: 50 };
  event_info = { info_1: '', info_2: '', info_3: '', info_4: '' };
  system_event = {
    contribute_initiated: { info_1: '', info_2: '', info_3: '', info_4: '' },
    contribute_cart: { info_1: '', info_2: '', info_3: '', info_4: '' },
    order_created: { info_1: '', info_2: '', info_3: '', info_4: '' }
  }

  insurance_vendors = {
    bima: { // vendor
      yearly: { // frequency
        care: { INR: 799 }, plus: { INR: 1599 } // plans
      },
      monthly: {
        care: { INR: 99 }, plus: { INR: 199 } // plans
      }
    },
    medibuddy: { // vendor
      yearly: { // frequency
        essentials: { INR: 1299 }, plus: { INR: 3499 } // plans
      }
    }
  };

  selected_insurance: {
    vendor: string, // 'bima' | 'medibuddy'
    frequency: string, // 'yearly' | 'monthly'
    plan: string, // 'care' | 'plus' | 'essentials'
    plan_text: string,
    plan_amount: number,
    currency: string
  } = null;

  insurance_plans_text = {
    care: 'Care',
    plus: 'Plus',
    essentials: 'Essentials'
  };

  switch_plan = new BehaviorSubject<string>('care');
  currency: any;
  tickerData = new BehaviorSubject<any>([]);
  prevOrderDetails: any;

  non_login_user_data: any;
  email_Pattern_Regex = /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/

  supported_sip_causes = {
    medical: { text: 'Medical' },
    animals: { text: 'Animals' },
    education: { text: 'Education' },
    food_hunger: { text: 'Food & Hunger' },
    elderly: { text: 'Elderly Care' },
    women_girls: { text: 'Women Empowerment' },
    widow: { text: 'Widow' },
    insurance: { text: 'Healthfirst' },
    sip_protect: { text: 'SIP Protect' }
  };
  default_sip_cause = 'medical';

  sip_status = {
    0: { text: 'New' },
    1: { text: 'Active' },
    2: { text: 'Lapsed' },
    3: { text: 'New' },
    4: { text: 'Cancelled' },
    5: { text: 'Cancel Requested' }
  }

  is_browser: any;
  isIndependanceDay;

  upiTimerOuter = new Subject<boolean>();
  isVariableLogin = false;
  varLoginData: { user: any, userdata: any } = { user: null, userdata: null };
  getCartInsurance = new BehaviorSubject<any>(null);
  countSubsCause;

  constructor(
    private router: Router,
    private actRoute: ActivatedRoute,
    private paymentService: PaymentService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.is_browser = isPlatformBrowser(this.platformId);
    if (this.is_browser) {
      this.router.events.pipe(filter((evt: any) => evt instanceof NavigationEnd), pairwise()).subscribe((events: RoutesRecognized[]) => {
        this.previousUrl = location.origin + events[0].urlAfterRedirects;
      });
      this.isPhonePe = window.navigator.userAgent.match('phonepe-webview') ? true : false;
      const paytmContainer = environment.production ? 'AppContainer' : 'PhoenixContainer';
      this.isPaytmMini = window.navigator.userAgent.match(paytmContainer) ? true : false;
      if (this.isPhonePe) {
        this.thirdPartyApp = true;
      }
      if (this.isPaytmMini) {
        this.thirdPartyApp = true;
      }
      if (this.thirdPartyApp) {
        this.social = false;
        this.paymentOption = false;
      } else {
        this.actRoute.queryParams.subscribe((params) => {
          this.social = +params['social'] === 0 ? false : true;
          this.paymentOption = +params['payops'] === 0 ? false : true;
          // this.isPhonePe = params['utm_source'] === 'phonepe' ? true : false;
        });
      }
    }
  }

  setNewMinSipAmounts(obj: any) {
    this.min_sip_amounts = { ...this.min_sip_amounts, ...obj };
  }

  /** Send last order value */
  setLastOrderValues(order: any) {
    this.lastOrderMode.next({ mode: order.payment_mode, value: order.payment_mode_value, gateway: order.payment_gateway });
    if (order.checksum) {
      let lastOrder = Object.assign(order, {
        mode_value: order.payment_mode_value,
        mode: order.payment_mode,
        gateway: order.payment_gateway
      });
      if (order.payment_mode === 'UPI') {
        lastOrder.upi_id = order.checksum;
      }
      if (order.payment_mode === 'UPI' && order.payment_gateway === 'camspay') {
        lastOrder = Object.assign(lastOrder, JSON.parse(order.checksum));
      }
      if (order.payment_gateway.match('stripe') && !this.pageName.match('sip_welcome')) {
        lastOrder = Object.assign(lastOrder, JSON.parse(order.checksum));
        this.stripeUsToken = lastOrder.token_1;
      }
      if (order?.donor?.full_name) {
        lastOrder.donor_name = order.donor.full_name.trim();
      }
      this.lastOrderInfo.next(lastOrder);
    }
  }

  /**Listen to the global variable and whenever
   * just need to call it like this
   * globalVarSetter.myKey = "its value";
   */
  listenToGlabalJsVar() {
    if (this.is_browser) {
      try {
        (<any>window).globalVarSetter = new Proxy({}, {
          set: (target: any, key, value) => {
            target[key] = value;
            this.globalVar.next(target);
            return true;
          }
        });
      } catch (e) { }
    }
  }

  async loadTranslationJson() {
    if (typeof window !== 'undefined') {
      const translationJson = await import(`../../../../assets/i18n/stories/${this.tranlatedLanguage}.json`);
      return translationJson.default;
    } else {
      return STORY_LANGUAGE;
    }
  }

  getTranslatedJson(keyString: string) {
    if (keyString) {
      return this.loadTranslationJson().then(translationJson => this.getObjFromStringNotation(translationJson, keyString));
    }
  }
  getTranslatedJsonObs(keyString: string) {
    const subject = new BehaviorSubject<any>('');
    this.languageObs.subscribe(async lang => {
      if (lang) {
        const translationJson = await this.loadTranslationJson();
        subject.next(this.getObjFromStringNotation(translationJson, keyString));
      }
      return lang;
    });
    return subject;
  }

  private getObjFromStringNotation(obj: any, keyString: string) {
    const keys = keyString.split('.');
    keys.forEach(key => {
      if (key in obj) {
        obj = obj[key];
      } else {
        return;
      }
    });
    return obj;
  }

  public getStartFundraiserWidgetStatus() {
    return this.startFundraiserWidgetStatus.asObservable();
  }

  public setStartFundraiserWidgetStatus(value: boolean) {
    this.startFundraiserWidgetStatus.next(value);
  }

  public getSubsCount(cause?: string) {
    if (!this.subsCountApiCalled || cause) {
      this.subsCountApiCalled = true;
      let query = '';
      if (cause) { query = '?cause=' + cause; }
      this.paymentService.getSubscriptions(query).subscribe((res: any) => {
        this.countSubsCause = query.split('=')[1];
        this.impactData = res.data.data;
        this.subsCount.next(res.data.data);
      });
    }
  }
}
